import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import GenericTable from "../../../Components/GenericTable";
import { Dropdown, Button, message, Modal } from "antd";
import {
  EllipsisOutlined,
  EditOutlined,
  DeleteOutlined,
  PlusOutlined,
} from "@ant-design/icons";

import "./style.css";
import { deleteServer, getAllServers } from "../../../API/server";

const EmailServers = () => {
  const [loading, setLoading] = useState(false);
  const [servers, setServers] = useState([]);

  const fetchAllServers = async () => {
    try {
      setLoading(true);
      const response = await getAllServers();
      if (Math.floor(response?.status / 100) === 2) {
        const data = response?.data || [];
        setServers(data);
      } else {
        message.error("Unexpected response from server.");
      }
    } catch (error) {
      message.error("Failed to fetch dashboard data Email Volume.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchAllServers();
  }, []);

  const navigate = useNavigate();

  const handleAddServer = () => {
    navigate("/add-email-server");
  };

  const openEditForm = (record) => {
    navigate("/edit-email-server", { state: { server: record } });
  };

  const handleDelete = (id) => {
    Modal.confirm({
      title: "Are you sure you want to delete this record?",
      okText: "Yes",
      okType: "danger",
      cancelText: "No",
      onOk: async () => {
        await deleteServer(id);
        const newData = servers.filter((item) => item.id !== id);
        setServers(newData);
        message.success(`Deleted record with ID ${id}`);
      },
    });
  };

  const renderStatus = (value) => (
    <span className={value ? "enabled" : "disabled"}>
      {value ? "Enable" : "Disable"}
    </span>
  );
  const columns = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      sorter: (a, b) => a.key - b.key,
      render: (text, record) => record.id,
    },
    { title: "Host", dataIndex: "host", key: "host", enableSearch: true },
    { title: "Port", dataIndex: "port", key: "port", enableSearch: true },
    {
      title: "User Name",
      dataIndex: "username",
      key: "username",
      enableSearch: true,
    },
    {
      title: "TLS",
      dataIndex: "use_tls",
      key: "use_tls",
      className: "tls-column",
      render: renderStatus,
      filters: [
        { text: "Enable", value: true },
        { text: "Disable", value: false },
      ],
      onFilter: (value, record) => record.use_tls === value,
    },
    {
      title: "SSL",
      dataIndex: "use_ssl",
      key: "use_ssl",
      className: "ssl-column",
      render: renderStatus,
      filters: [
        { text: "Enable", value: true },
        { text: "Disable", value: false },
      ],
      onFilter: (value, record) => record.ssl === value,
    },
    {
      title: "Created At",
      dataIndex: "created_at",
      key: "created_at",
      render: (value) => new Date(value).toLocaleString(),
      sorter: (a, b) => new Date(a.created_at) - new Date(b.created_at),
    },
    {
      title: "Updated At",
      dataIndex: "updated_at",
      key: "updated_at",
      render: (value) => new Date(value).toLocaleString(),
      sorter: (a, b) => new Date(a.updated_at) - new Date(b.updated_at),
    },
    {
      title: "Actions",
      key: "actions",
      align: "center",
      render: (_, record) => {
        const menu = {
          items: [
            {
              key: "edit",
              icon: <EditOutlined />,
              label: "Edit",
              className: "edit-option",
              onClick: () => openEditForm(record),
            },
            {
              key: "delete",
              icon: <DeleteOutlined />,
              label: "Delete",
              className: "delete-option",
              onClick: () => handleDelete(record.id),
            },
          ],
        };

        return (
          <Dropdown menu={menu} trigger={["click"]} placement="bottomRight">
            <Button
              type="text"
              icon={
                <EllipsisOutlined style={{ fontSize: 18, color: "#8B899F" }} />
              }
              onClick={(e) => e.preventDefault()}
            />
          </Dropdown>
        );
      },
    },
  ];

  return (
    <div className="email">
      <div className="btn-container">
        <Button
          type="primary"
          icon={<PlusOutlined />}
          onClick={handleAddServer}
        >
          Add Server
        </Button>
      </div>
      <GenericTable
        title="Email Servers"
        dataSource={servers}
        columns={columns}
        enableRowSelection={true}
      />
    </div>
  );
};

export default EmailServers;
